//Belongs to JobInterview Entity
export const InterviewStatusEnum = Object.freeze({
  AwaitingConfirmation: 0, // Dates proposed, waiting for candidate confirmation
  Confirmed: 1, // Candidate selected a date
  Completed: 2, // Feedback Added
  Cancelled: 3, // Interview cancelled
});
